// extracted by mini-css-extract-plugin
export default {"overview":"Overview_overview__kYfTU"};